<p [innerHTML]="'document.delete.confirmation' | translate: { documentName }"></p>
<p
  *ngIf="isHintVisible"
  [innerHTML]="'document.delete.hint' | translate"
></p>
